import React, { useContext } from "react";
import classNames from "classnames";

import { EventContext } from "@gp/components";

import { useLiveWidgetStore } from "@state/hooks/live-widgets";
import { WidgetLocation } from "@data-types/live-widget/WidgetLocation";

export default function PinWidgetButton() {
	const event = useContext(EventContext);
	const widgetStore = useLiveWidgetStore();
	const activeWidget = widgetStore.findActiveWidget(
		event.id,
		WidgetLocation.EVENT_OFFER
	);
	const isActiveStream = widgetStore.findActiveLiveStreamWidget(
		event.id,
		WidgetLocation.EVENT_OFFER
	);
	const isPinned = activeWidget?.isPinned;

	if (!activeWidget) {
		return null;
	}

	const buttonClasses = classNames(
		"at-actionPinWidget widget__pin btn btn--square btn--square--sml",
		{
			"event__pin--active btn--secondary": isPinned,
			"btn--secondary--inverted": !isPinned,
			"event__pin--live": isActiveStream,
		}
	);

	const iconClasses = classNames("widget__icon u-icon u-icon--sml", {
		"u-icon--action--pinned": isPinned,
		"u-icon--action--pin": !isPinned,
	});

	return (
		<button
			type="button"
			className={buttonClasses}
			onClick={() =>
				widgetStore.toggleWidgetPin(
					event.id,
					WidgetLocation.EVENT_OFFER
				)
			}
		>
			<i className={iconClasses} />
		</button>
	);
}
